export default __webpack_public_path__ + "static/media/alert.34718a73.svg";